import { httpPost, httpPatchMerge, httpDelete } from './http'
import type { TEntityId } from '~/types/models'
import type { ITeamMemberLastSelectedState } from '~/types/teamMember/models'

const apiEntityPath = '/api/teammemberlastselectedstates'

export async function createTeamMemberLastSelectedState(
  entity: ITeamMemberLastSelectedState
) {
  const callingMn = createTeamMemberLastSelectedState.name
  const apiPath = apiEntityPath
  return httpPost<ITeamMemberLastSelectedState>({
    callingMn,
    apiPath,
    entity,
  })
}

export async function updateTeamMemberLastSelectedState(
  entityData: Partial<ITeamMemberLastSelectedState>,
  id: TEntityId
) {
  const callingMn = updateTeamMemberLastSelectedState.name
  const apiPath = `${apiEntityPath}/${id}`
  type TPartialTeamMemberLastSelectedState =
    Partial<ITeamMemberLastSelectedState>
  return httpPatchMerge<TPartialTeamMemberLastSelectedState>({
    callingMn,
    apiPath,
    entityData,
  })
}

export async function deleteTeamMemberLastSelectedState(
  entityData: ITeamMemberLastSelectedState
) {
  const callingMn = deleteTeamMemberLastSelectedState.name
  const apiPath = apiEntityPath
  return httpDelete<ITeamMemberLastSelectedState>({
    callingMn,
    apiPath,
    entityData,
  })
}
